'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isAssignmentV2 = undefined;

var _messageTypes = require('../constants/messageTypes');

var _isType = require('./isType');

var isAssignmentV2 = exports.isAssignmentV2 = (0, _isType.isType)(_messageTypes.ASSIGNMENT_V2);


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/pubnub-message/operators/isAssignmentV2.js
// module id = 415
// module chunks = 2 3